import { Game } from '../../../interfaces/Games.interface';

/**
 * Get all teams from the games data
 * @param games - List of all games
 * @returns - Array of all Teams (without duplicates), sorted alphabetically
 */
export const getTeams = (games: Game[]): string[] => {
  const teamsSet = new Set<string>();
  games.forEach((game: Game) => {
    teamsSet.add(game.team_home);
    teamsSet.add(game.team_away);
  });

  const teamsArray = Array.from(teamsSet).sort((a, b) => a.localeCompare(b));
  return teamsArray;
};

/**
 * Get all teams from a specific competition
 * @param games - List of all games
 * @param competitionName - Name of the competition to filter by
 * @returns - Array of all Teams in the specified competition (without duplicates), sorted alphabetically
 */
export const getTeamsByCompetition = (
  games: Game[],
  competitionName: string
): string[] => {
  const teamsSet = new Set<string>();

  games.forEach((game: Game) => {
    if (game.tournament_name === competitionName) {
      teamsSet.add(game.team_home);
      teamsSet.add(game.team_away);
    }
  });

  return Array.from(teamsSet).sort((a, b) => a.localeCompare(b));
};
